import { render, staticRenderFns } from "./LabelDeleteModal.vue?vue&type=template&id=f416ea2a&scoped=true"
import script from "./LabelDeleteModal.vue?vue&type=script&lang=js"
export * from "./LabelDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./LabelDeleteModal.vue?vue&type=style&index=0&id=f416ea2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f416ea2a",
  null
  
)

export default component.exports